import './observability/initNewRelic';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './rematch';
import { Provider } from 'react-redux';
import { captureUtmSource } from './utils/campaignAttribution';

// Above root.render(...), and not in App.js or a route effect: several
// routes (PublicRouter's Navigate, the login redirects) discard the query
// string before any component effect would see it.
captureUtmSource();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
